// extracted by mini-css-extract-plugin
export default {"item":"_cd25cc7","link":"_cc0eae32","title":"_358ae5d2","imageContainer":"_3360692","image":"_c7e868b5","cta":"_2402f624","shimmerLoadingBackground":"_25b24dff"};